import SpriteSymbol from "../../../../../../../../../root/.zend/plugin/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../../../../../root/.zend/plugin/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "StopSplid",
  "use": "StopSplid-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"StopSplid\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M3 11.4616C3 12.3112 3.68885 13 4.53848 13H11.4616C12.3112 13 13 12.3112 13 11.4616V4.53848C13 3.68885 12.3112 3 11.4616 3H4.53848C3.68885 3 3 3.68885 3 4.53848V11.4616Z\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol